import {useAppContext, useBehavioralContext, useUserContext} from "../../../contexts";
import {useEffect} from "preact/hooks";
import {useState} from "preact/compat";
import {api} from "../../../services";

export const useContent = (props) => {
    // Destructured props
    const {handleCartLoader} = props;

    // State to control the current step of the content component.
    // Its default value is null, as it was initially designed to be only the cart data.
    const [currentStep, setCurrentStep] = useState(null);

    // Gets the current store location id
    const {storeLocation} = useAppContext();

    // Retrieves the flag to check whether the terms of use have been accepted or not
    const [{}, {}, {
        acceptedTermUse,
    }] = useUserContext();

    // Retrieves the major component data from the behavioral context
    const {
        sidebarCartData,
        handleCart
    } = useBehavioralContext();

    // Procedure to handle the "currentStep" state
    const handleCurrentStep = (
        target = undefined
    ) => {
        // Prevents unnecessary errors
        if (!target) {
            return;
        }

        setCurrentStep(target);
    }

    // Procedure to fetch the product data from the given URL
    const fetchProductDataFromURL = async () => {
        handleCartLoader(true);

        try {
            // The actual API call
            let response =
                await api.get(`/v1/cms/view?url=${sidebarCartData.url}&regionId=${storeLocation.id}`);

            // Assigns the response data to the main cart state
            handleCart("_", "_", {
                isOpen:         true,
                newProductData: {
                    selectedAmount:             1,
                    productData:                response.data,
                    productCategoryServiceType: response.data["product"]?.categoryServiceType,
                },
                // Here we clear the URL property because it's no longer needed
                url:                            ""
            });
        } catch (e) {

        } finally {
            handleCartLoader(false);
        }
    }

    const validateTermsOfUse = () => {
        // Retrieves term of use data
        const categoriesList =
            sidebarCartData.newProductData.productData?.product?.categories;

        // if exist categories into product
        if (categoriesList && categoriesList.length > 0) {
            const vaccineCategory = categoriesList.find((category) => category.urlKey === "vacinas");

            if (vaccineCategory && !acceptedTermUse) {
                setCurrentStep("termAccept");
            } else {
                setCurrentStep("picker");
            }
        }
    }

    // Main trigger
    useEffect(() => {
        // If the sidebar cart component is closed,
        // then it resets it to its default value.
        if (!sidebarCartData.isOpen) {
            setCurrentStep(null);

            return;
        }

        // This one is in case the user is adding a product from outside the product page.
        // In this case, we call this procedure to firstly fetch the product data
        // from the given URL and only then validate whether we should display the
        // vaccine term consent or the picker step.
        if (sidebarCartData.url) {
            fetchProductDataFromURL().then();

            return;
        }

        // Checks if a product is being added to the cart and, if so,
        // bootstraps the component from the first step.
        if (Object.keys(sidebarCartData.newProductData).length > 0) {
            validateTermsOfUse();
        } else {
            setCurrentStep("resume");
        }
    }, [
        sidebarCartData.isOpen,
        sidebarCartData.newProductData,
        sidebarCartData.url
    ]);

    return {
        currentStep,
        handleCurrentStep
    }
}
